import { Link, Typography } from '@mui/material';

interface EmailLinkProps {
    email: string;
}

const EmailLink = ({ email }: EmailLinkProps) => {
    const handleEmailClick = () => {
        const mailtoUrl = `mailto:${email}`;
        window.location.href = mailtoUrl;
    };

    return (
        <Typography variant="h4">
            <Link
                onClick={handleEmailClick}
                color="primary"
                underline="always"
                sx={{ cursor: 'pointer' }}>
                {email}
            </Link>
        </Typography>
    );
};

export default EmailLink;
